export default function ImagesnotFound() {
    return (
        <div style={{ textAlign: 'center' }}>
            <p>Картинки с таким именем нет</p>
        </div>
    );
}
